import * as moment from 'moment';
import * as React from 'react';
import { IFieldConfig } from '../../../../interface/field-config.interface';
import { DatePicker } from '@atlaskit/datetime-picker';
import { Label } from '@atlaskit/field-base';
import { observer } from 'mobx-react';

interface IDateFieldProps {
  onChange: any;
  onBlur: any;
  isInvalid: boolean;
}

const FORMAT = 'YYYY-MM-DDT00:00:00';
export const DateField = observer((props: IDateFieldProps & IFieldConfig) => {
  return (
    <div>
      <Label
        htmlFor={props.applyFormKey}
        label={props.label}
      />
      <DatePicker
        isDisabled={props.disabled}
        id={props.applyFormKey}
        placeholder={props.placeholder}
        isInvalid={props.isInvalid}
        onChange={(value) => !props.onChange ? undefined : props.onChange(moment.utc(value).format(FORMAT))}
        onBlur={props.onBlur}
      />
    </div>
  );
});
